module.exports = __webpack_public_path__ + "static/img/qualifications_row_6.51a9bc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_6.png
// module id = fmqy
// module chunks = 1